import styled from "styled-components";
import { ShimmerMixin, ShimmerMixinProps } from "../ReusableStyledComponents/ShimmerCSSEffect";
import { V3HeadlineH5 } from "../Typography";

export const V3DashboardListItem = styled.div<ShimmerMixinProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 24px 6px 9px;
    background: #F4F4F6;
    border-radius: 12px;
    min-height: 66px;
    margin-bottom: 12px;

    > div {
        &:nth-child(2) {
            width: 100%;
            max-width: calc(100% - 80px);
        }
    }

    ${ShimmerMixin}
`;

export const V3DashboardListItemImageContainer = styled.div`
    width: 72px;
    height: 54px;
    border-radius: 6px;
    overflow: hidden;
    background: ${({ theme }) => theme ? theme.v3.colors.grey96 : "white"};
    position: relative;
    margin-right: 18px;
    flex-shrink: 0;
`

export const V3DashboardListItemImageImage = styled.img`
    width: 120px;
    height: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
`

export const V3DashboardListItemImageImageShimmer = styled.div<{ $shimmerEnabled: boolean }>`
    width: 300px;
    height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    

    ${ShimmerMixin}
`

export const V3DashboardListItemTitle = styled(V3HeadlineH5)`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100%);
    display: inline-block;
`;

export const V3DashboardListNumber = styled.div`
    flex-shrink: 0;
    margin-left: auto;
`;